// DS: i9.7
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const DollarSign: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
        <path d="M15.208 26v-2.072q-1.512-.136-2.706-.704-1.195-.568-1.866-1.609-.67-1.04-.634-2.587l.024-.052h3.463q0 1.41.756 2.019t1.902.61q1.11 0 1.695-.505.597-.516.598-1.378 0-.85-.574-1.388-.56-.536-1.938-.999-1.805-.567-2.988-1.198-1.17-.642-1.755-1.504-.573-.873-.573-2.145 0-1.767 1.304-2.892 1.317-1.136 3.536-1.335V6h1.939v2.292q2.134.274 3.353 1.546c.821.841 1.211 1.757 1.195 3.11l-.037.052H18.44c0-.827-.187-1.283-.586-1.732q-.596-.673-1.61-.673-1.048 0-1.572.526-.512.515-.512 1.377 0 .82.536 1.336.55.505 2 .999 1.792.61 2.963 1.262 1.182.64 1.756 1.503.585.863.585 2.103 0 1.82-1.317 2.924-1.305 1.093-3.536 1.293V26z"></path>
      </svg>
    </IconWrap>
  );
};
DollarSign.displayName = 'DollarSign';

export default DollarSign;
